export type JsonObject = Readonly<Record<string, unknown>>

/** Reads a JSON data file field by field; every failure names the file and the field path. */
export class JsonReader {
  private readonly description: string

  constructor(description: string) {
    this.description = description
  }

  fail(path: string, problem: string): never {
    throw new Error(`Loading ${this.description} failed: ${path} ${problem}`)
  }

  object(value: unknown, path: string): JsonObject {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) this.fail(path, `must be an object, got ${JSON.stringify(value)}`)
    return value as JsonObject
  }

  string(value: unknown, path: string): string {
    if (typeof value !== 'string' || value.trim() === '') this.fail(path, `must be a non-empty string, got ${JSON.stringify(value)}`)
    return value
  }

  positiveInteger(value: unknown, path: string): number {
    if (typeof value !== 'number' || !Number.isSafeInteger(value) || value <= 0) this.fail(path, `must be a positive integer, got ${JSON.stringify(value)}`)
    return value
  }

  boolean(value: unknown, path: string): boolean {
    if (typeof value !== 'boolean') this.fail(path, `must be true or false, got ${JSON.stringify(value)}`)
    return value
  }

  array(value: unknown, path: string): readonly unknown[] {
    if (!Array.isArray(value) || value.length === 0) this.fail(path, `must be a non-empty array, got ${JSON.stringify(value)}`)
    return value
  }
}
